module.exports = __webpack_public_path__ + "img/152.4db6ddc5.jpg";